export const anchorLinks = (introRan,isHomepage,isEdition) => {

  const anchorLink = '.js-anchor-link';
  let introClicked = false;
  const $page = $([document.documentElement, document.body]);

  const init = () => {
    bind();
  };

  const bind = () => {

    function scrollToElement(element) {

      // $page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
      //   $page.stop();
      // });

      $page.animate({ scrollTop: $('#'+element).offset().top - $('.js-header').height() }, 800, function(){
        $page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
      });
  
    }

    $(anchorLink).on('click', function(e) {
      e.preventDefault();
      console.log('anchor link clicked');
      if($(this).hasClass('js-push')) {
        //Intro is clicked. Update variable to make sure the intro scroll animation doesn't run again because of the timeout function
        introClicked = true;
      }
      const element = $(this).data('href');
      scrollToElement(element);
    });


    function introScrollAnimation() {
      if(introClicked == false && window.scrollY < 200) {
        if($('.js-intro').length > 0) {
          scrollToElement('main');
        }
      }
    }

    const introTimeout = setTimeout(introScrollAnimation, 2000);

  };

  init();

};
